import { LENDER_ID } from "../../../configs/constants";
export const showBankDetails = (lenderAccountId) => {
    switch (lenderAccountId.toLowerCase()) {
        case LENDER_ID.TATA:
            return false;
        case LENDER_ID.NUVAMA:
            return false;
        case LENDER_ID.MIRAE:
            return false;
        default:
            return true;
    }
};
